import React from "react";
import { createColumnHelper } from "@tanstack/react-table";

const columnHelper = createColumnHelper<any>();

export const getInboundPickupSummaryColumns = () => [
  columnHelper.accessor("type", {
    id: "type",
    header: "",
    cell: (cellProps) => (
      <div
        style={{
          fontWeight: 600,
          color: "rgba(79, 95, 114, 0.72)",
          marginRight: 4,
          textAlign: "left",
        }}
      >
        {cellProps.getValue()}
      </div>
    ),
    size: 300,
  }),
  columnHelper.accessor("unassigned", {
    id: "unassigned",
    header: () => <div style={{ textAlign: "right" }}>Unassigned</div>,
    cell: (cellProps) => (
      <div style={{ marginRight: 5 }}>{cellProps.getValue()}</div>
    ),
    size: 390,
  }),
  columnHelper.accessor("assigned", {
    id: "assigned",
    header: () => <div style={{ textAlign: "right" }}>Assigned</div>,
    cell: (cellProps) => (
      <div style={{ marginRight: 5 }}>{cellProps.getValue()}</div>
    ),
    size: 390,
  }),
  columnHelper.accessor("completed", {
    id: "completed",
    header: () => <div style={{ textAlign: "right" }}>Completed</div>,
    cell: (cellProps) => (
      <div style={{ marginRight: 5 }}>{cellProps.getValue()}</div>
    ),
    size: 390,
  }),
];
